<div class="breadcrumb-area">
    <h1>Dashboard</h1>

    <ol class="breadcrumb">
        <li class="item"><a routerLink="/admin-dashboard"><i class='bx bx-home-alt'></i></a></li>

        <li class="item">Dashboard</li>

        <li class="item">Reviews</li>
    </ol>
</div>

<div class="card visitor-reviews-box mb-30">
    <div class="card-header d-flex justify-content-between align-items-center">
        <h3>Visitor Reviews</h3>

        <div class="dropdown">
            <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class='bx bx-dots-horizontal-rounded' ></i>
            </button>
            <div class="dropdown-menu">
                <a class="dropdown-item d-flex align-items-center" href="#">
                    <i class='bx bx-show'></i> View
                </a>
                <a class="dropdown-item d-flex align-items-center" href="#">
                    <i class='bx bx-edit-alt'></i> Edit
                </a>
                <a class="dropdown-item d-flex align-items-center" href="#">
                    <i class='bx bx-trash'></i> Delete
                </a>
                <a class="dropdown-item d-flex align-items-center" href="#">
                    <i class='bx bx-printer'></i> Print
                </a>
                <a class="dropdown-item d-flex align-items-center" href="#">
                    <i class='bx bx-download'></i> Download
                </a>
            </div>
        </div>
    </div>

    <div class="card-body">
        <div class="user-review">
            <div class="btn-box">
                <button type="button" class="btn btn-sm btn-primary">Reply</button>
                <button type="button" class="btn btn-sm btn-danger ml-3">Delete</button>
            </div>

            <img src="assets/img/default/admin.jpg" alt="image">
            
            <div class="review-rating">
                <div class="review-stars">
                    <i class='bx bxs-star'></i>
                    <i class='bx bxs-star'></i>
                    <i class='bx bxs-star'></i>
                    <i class='bx bxs-star'></i>
                    <i class='bx bxs-star'></i>
                </div>

                <span class="d-inline-block">Andy Nguyễn</span>
            </div>

            <span class="d-block sub-comment">Excellent</span>
            <p>Very well built theme, couldn't be happier with it. Can't wait for future updates to see what else they add in.</p>
        </div>

        <div class="user-review">
            <div class="btn-box">
                <button type="button" class="btn btn-sm btn-primary">Reply</button>
                <button type="button" class="btn btn-sm btn-danger ml-3">Delete</button>
            </div>

            <img src="assets/img/default/admin.jpg" alt="image">
            
            <div class="review-rating">
                <div class="review-stars">
                    <i class='bx bxs-star'></i>
                    <i class='bx bxs-star'></i>
                    <i class='bx bxs-star'></i>
                    <i class='bx bxs-star'></i>
                    <i class='bx bxs-star'></i>
                </div>

                <span class="d-inline-block">Sarah Taylor</span>
            </div>

            <span class="d-block sub-comment">Video Quality!</span>
            <p>Was really easy to implement and they quickly answer my additional questions!</p>
        </div>

        <div class="user-review">
            <div class="btn-box">
                <button type="button" class="btn btn-sm btn-primary">Reply</button>
                <button type="button" class="btn btn-sm btn-danger ml-3">Delete</button>
            </div>

            <img src="assets/img/default/admin.jpg" alt="image">
            
            <div class="review-rating">
                <div class="review-stars">
                    <i class='bx bxs-star'></i>
                    <i class='bx bxs-star'></i>
                    <i class='bx bxs-star'></i>
                    <i class='bx bxs-star'></i>
                    <i class='bx bxs-star'></i>
                </div>

                <span class="d-inline-block">David Warner</span>
            </div>

            <span class="d-block sub-comment">Perfect Coding!</span>
            <p>Stunning design, very dedicated crew who welcome new ideas suggested by customers, nice support.</p>
        </div>

        <div class="user-review">
            <div class="btn-box">
                <button type="button" class="btn btn-sm btn-primary">Reply</button>
                <button type="button" class="btn btn-sm btn-danger ml-3">Delete</button>
            </div>

            <img src="assets/img/default/admin.jpg" alt="image">
            
            <div class="review-rating">
                <div class="review-stars">
                    <i class='bx bxs-star'></i>
                    <i class='bx bxs-star'></i>
                    <i class='bx bxs-star'></i>
                    <i class='bx bxs-star'></i>
                    <i class='bx bxs-star'></i>
                </div>

                <span class="d-inline-block">Andy Nguyễn</span>
            </div>

            <span class="d-block sub-comment">Excellent</span>
            <p>Very well built theme, couldn't be happier with it. Can't wait for future updates to see what else they add in.</p>
        </div>

        <div class="user-review">
            <div class="btn-box">
                <button type="button" class="btn btn-sm btn-primary">Reply</button>
                <button type="button" class="btn btn-sm btn-danger ml-3">Delete</button>
            </div>

            <img src="assets/img/default/admin.jpg" alt="image">
            
            <div class="review-rating">
                <div class="review-stars">
                    <i class='bx bxs-star'></i>
                    <i class='bx bxs-star'></i>
                    <i class='bx bxs-star'></i>
                    <i class='bx bxs-star'></i>
                    <i class='bx bxs-star'></i>
                </div>

                <span class="d-inline-block">Sarah Taylor</span>
            </div>

            <span class="d-block sub-comment">Video Quality!</span>
            <p>Was really easy to implement and they quickly answer my additional questions!</p>
        </div>

        <div class="user-review">
            <div class="btn-box">
                <button type="button" class="btn btn-sm btn-primary">Reply</button>
                <button type="button" class="btn btn-sm btn-danger ml-3">Delete</button>
            </div>

            <img src="assets/img/default/admin.jpg" alt="image">
            
            <div class="review-rating">
                <div class="review-stars">
                    <i class='bx bxs-star'></i>
                    <i class='bx bxs-star'></i>
                    <i class='bx bxs-star'></i>
                    <i class='bx bxs-star'></i>
                    <i class='bx bxs-star'></i>
                </div>

                <span class="d-inline-block">David Warner</span>
            </div>

            <span class="d-block sub-comment">Perfect Coding!</span>
            <p>Stunning design, very dedicated crew who welcome new ideas suggested by customers, nice support.</p>
        </div>
    </div>
</div>